module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/UQZTA2/tc-custom/9781634868983.jpg?1723404184406",
      "alt": "This image is the cover for the book High School Reunion"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("High School Reunion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Elizabeth is back in Indiana for her ten year high school reunion. She moved to New Mexico shortly after graduating and hadn’t seen her friends since. But while catching up, she runs into someone from her past ... literally."), _c('br'), _c('br'), _vm._v("Her ex-girlfriend, Veronica."), _c('br'), _c('br'), _vm._v("After their bad break-up and Elizabeth moving away, Veronica focused on following her dream of becoming a photographer. When she runs into Elizabeth, neither of them can deny the sparks. Will they act on them or push them aside?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Megan E. Bean\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("I grew up in Ohio and moved to Arizona at the age of 22. I live with my girlfriend and our three dogs. It has always been my dream to write; when I was a young girl, I would write stories on my typewriter. I also work as an equipment operator at a golf course. I enjoy hiking, camping, and bike riding.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0